import React from "react";
//MUI
import { Box, Grid, Typography } from "@mui/material";
//画像
import HomeIcon from "@mui/icons-material/Home";
import ContactObject from "./material/contact-object.png";
import CharacterRed from "./material/character_red.png";
import CharacterBlue from "./material/character_blue.png";
import CharacterPurple from "./material/character_purple.png";
import { NotoSansJp } from "./TextStyle";
import useMediaQuery from "@mui/material/useMediaQuery";
import DocumentMeta from "react-document-meta";
import { useBranch, Navigate } from "./useBranch";

const positions: Array<["left" | "right", "top" | "bottom"]> = [
  ["left", "top"],
  ["left", "bottom"],
  ["right", "bottom"],
  ["right", "top"],
];

const ClassOverview = () => {
  const isSmartphone = useMediaQuery("(max-width:767px)");
  const state = useBranch();
  if (state.status === "loading") return null;
  if (state.status === "notfound") return <Navigate to="/" replace />;
  const branch = state.branch;

  const meta = {
    title: `${branch.roomName}｜教室概要`,
    description: `${branch.roomName}の教室概要ページ。住所・駐車場の有無など、教室に通う前に知っておきたい基本情報をご紹介します。`,
    canonical: `https://tht-group.co.jp/${branch.id}/classoverview`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: [...branch.top.regionKeywords, "教室概要", "体操教室"].join(","),
      },
    },
  };

  return (
    <DocumentMeta {...meta}>
      <Box sx={{ width: "100vw" }}>
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "100%", mt: isSmartphone ? "40px" : "100px" }}>
            <Grid
              container
              direction="column"
              sx={{
                justifyContent: "center",
                alignItems: "center",
                p: isSmartphone ? "0% 7% 6% 7%" : "0",
              }}
            >
              <Typography
                component="h1"
                sx={{
                  color: "darkorange", // 明るい黄色
                  fontSize: isSmartphone ? "20px" : "35px",
                  fontWeight: "bold",
                  pt: isSmartphone ? "0" : "50px",
                  mb: isSmartphone ? "10px" : "20px",
                  ...NotoSansJp,
                }}
              >
                {branch.roomName}｜教室概要
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#333333",
                  mb: "40px",
                }}
              >
                <HomeIcon fontSize="small" />
                <Typography
                  sx={{ fontSize: isSmartphone ? "14px" : "16px", mx: 1 }}
                >
                  {">"}
                </Typography>
                <Typography
                  sx={{
                    color: "#333333",
                    fontWeight: 500,
                    fontSize: isSmartphone ? "14px" : "16px",
                    ...NotoSansJp,
                  }}
                >
                  教室概要
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  m: isSmartphone ? "50px 0" : "150px 0 0 0",
                }}
              >
                <Box
                  sx={{
                    maxWidth: "1150px",
                    mr: "auto",
                    ml: "auto",
                    position: "relative",
                  }}
                >
                  <Box sx={{ pr: isSmartphone ? "0" : "40%" }}>
                    <Box sx={{ width: "100%", display: "flex" }}>
                      <img
                        src={CharacterRed}
                        alt="point_object"
                        style={{
                          position: "absolute",
                          width: isSmartphone ? "25px" : "86px",
                          top: isSmartphone ? "150px" : "200px",
                          right: "58px",
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      mt: isSmartphone ? "-50px" : "-100px",
                      pl: isSmartphone ? "0" : "30%",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        mr: "auto",
                        ml: "auto",
                        position: "relative",
                      }}
                    >
                      {positions.map(([horiz, vert], index) => (
                        <img
                          key={index}
                          src={ContactObject}
                          alt="yellow_circle"
                          style={{
                            width: isSmartphone ? "10px" : "20px",
                            height: isSmartphone ? "10px" : "20px",
                            position: "absolute",
                            [horiz]: isSmartphone ? "15px" : "20px",
                            [vert]: isSmartphone ? " 15px" : "20px",
                          }}
                        />
                      ))}
                      <Box
                        sx={{
                          bgcolor: "#FFFFFF",
                          p: isSmartphone ? "30px 30px 40px 30px" : "50px",
                          borderRadius: "20px",
                        }}
                      >
                        <Typography
                          component="h2"
                          sx={{
                            color: "#333333",
                            fontWeight: "bold",
                            fontSize: isSmartphone ? "20px" : "25px",
                            pt: "10px",
                            mb: "20px",
                            ...NotoSansJp,
                          }}
                        >
                          ご挨拶
                        </Typography>
                        <Box sx={{ mb: "20px" }}>
                          {[
                            "はじめまして、代表の高田と申します。",
                            "私たち土日だけ体操教室で大切にしているのは、ただ技を覚えるだけでなく、やる気と自信、落ち着きと集中力、そして自分で考えて行動する力 を自然に育てることです。",
                            "子どもたちが「今日も楽しかった！」と笑顔で帰り、次の週末には「こんな技に挑戦したい！」と目を輝かせてくれる――そんな循環を生むために、少人数制 でじっくり向き合い、マット・跳び箱・鉄棒・トランポリンの４種目を安全に、そして思いきり楽しみながら指導します。",
                          ].map((text, i) => (
                            <Typography
                              key={i}
                              sx={{
                                color: "#333333",
                                fontWeight: 500,
                                fontSize: isSmartphone ? "14px" : "16px",
                                mb: "10px",
                                ...NotoSansJp,
                              }}
                            >
                              {text}
                            </Typography>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  m: isSmartphone ? "0 0 50px 0" : "150px 0",
                }}
              >
                <Box
                  sx={{
                    maxWidth: "1300px",
                    mx: "auto",
                    position: "relative",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "40px",
                  }}
                >
                  <Grid
                    container
                    direction={isSmartphone ? "column" : "row"}
                    sx={{
                      justifyContent: "center",
                    }}
                  >
                    {/* 左側：タイトル */}
                    <Box
                      sx={{
                        width: isSmartphone ? "100%" : "30.538%",
                        position: "relative",
                      }}
                    >
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography
                          sx={{
                            color: "#E0B24B",
                            fontSize: isSmartphone ? "15px" : "20px",
                            fontWeight: "bold",
                            mb: isSmartphone ? "20px" : "10px",
                          }}
                        >
                          INFORMATION
                        </Typography>
                        <Typography
                          component="h2"
                          sx={{
                            color: "#333333",
                            fontSize: isSmartphone ? "20px" : "25px",
                            fontWeight: "bold",
                            mb: isSmartphone ? "20px" : "0",
                            ...NotoSansJp,
                          }}
                        >
                          基本情報
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          position: "absolute",
                          top: isSmartphone ? "40px" : "178px",
                          left: isSmartphone ? "210px" : "56px",
                          mb: isSmartphone ? "20px" : "0",
                          zIndex: 1,
                        }}
                      >
                        <img
                          src={CharacterBlue}
                          alt="blue"
                          style={{ width: isSmartphone ? "37px" : "75px" }}
                        />
                      </Box>
                    </Box>

                    {/* 右側：情報テーブルと装飾 */}
                    <Box
                      sx={{
                        width: isSmartphone ? "100%" : "69.462%",
                        position: "relative",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: "-74px",
                          left: "458px",
                          display: isSmartphone ? "none" : "block",
                          zIndex: 1,
                        }}
                      >
                        <img
                          src={CharacterPurple}
                          alt="yellow"
                          style={{ width: "20%" }}
                        />
                      </Box>
                      {/* 情報テーブル */}
                      <Box
                        component="table"
                        sx={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        {[
                          ["教室名", branch.roomName],
                          ["住所", `${branch.zip}\n${branch.address}`],
                          ["駐車場", branch.hasParking ? "あり" : "なし：近くの有料駐車場をご利用ください"],
                        ].map(([label, value], i) => (
                          <Box
                            component="tr"
                            key={i}
                            sx={{
                              display: isSmartphone ? "block" : "table-row",
                              borderTop: i === 0 ? "1px solid #D9E7F0" : "none",
                              borderBottom: "1px solid #D9E7F0",
                              mt: isSmartphone ? "9%" : "0",
                            }}
                          >
                            <Box
                              component="td"
                              sx={{
                                display: isSmartphone ? "block" : "table-cell",
                                width: isSmartphone ? "100%" : "30%",
                                color: "#333333",
                                fontWeight: 500,
                                fontSize: isSmartphone ? " 14px" : "16px",
                                p: isSmartphone ? "16px 5px 4px" : "30px 5px",
                                whiteSpace: "normal",
                                ...NotoSansJp,
                              }}
                            >
                              {label}
                            </Box>
                            <Box
                              component="td"
                              sx={{
                                display: isSmartphone ? "block" : "table-cell",
                                width: isSmartphone ? "100%" : "70%",
                                color: "#333333",
                                fontSize: isSmartphone ? "14px" : "16px",
                                p: isSmartphone ? "4px 5px 16px" : "30px 5px",
                                whiteSpace: isSmartphone ? "pre-line" : "normal",
                                fontWeight: 500,
                                ...NotoSansJp,
                              }}
                            >
                              {value}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Box>
    </DocumentMeta>
  );
};

export default ClassOverview;
